import { Component } from '@cms-max/medicare-api-sdk'
import { Alert } from '@cmsgov/design-system'
import { ContentLayout } from 'components/Layouts'
import { BackToPremiumsLink } from 'containers/Premiums/components/BackToPremiums'
import { BackToPremiumsBreadcrumbFeatureFlagged } from 'containers/Premiums/components/BackToPremiumsBreadcrumb'
import { useQueryParams } from 'hooks/useQueryParams'
import { useTranslation } from 'react-i18next'
import { Redirect } from 'react-router'

export function EasyPayErrorPage () {
  const { t } = useTranslation('easyPayCommon', { keyPrefix: 'errorPage' })
  const queryParams = useQueryParams()
  const code = queryParams.get('code')

  // If we can figure out error code, redirect to Easy Pay summary page
  if (!code) {
    return <Redirect to={`/premiums/easy-pay`} />
  }

  return (
    <ContentLayout
      nav={<BackToPremiumsBreadcrumbFeatureFlagged />}
      className="ds-u-padding-bottom--7"
      heading={t('heading')}
      width="wide"
      withPrintButton
      printComponent={Component.EasyPay}
    >
      <div className="ds-l-container">
        <div className="ds-u-measure--wide">
          {code === 'unavailable'
            ? (
              <Alert variation="error" heading={t('unavailableAlert.heading')}>
                {t('unavailableAlert.content')}
              </Alert>
              )
            : (
              <Alert variation="error" heading={t('ineligibleAlert.heading')}>
                {t('ineligibleAlert.content')}
              </Alert>
              )}
        </div>

        <div className="ds-u-margin-top--3">
          <BackToPremiumsLink />
        </div>
      </div>
    </ContentLayout>
  )
}
